$(document).ready(function(){
    var swiper = new Swiper(".kits-sliders", {
      draggable: false,
      swiper: false,
      noSwipingClass: "kits-sliders",
      navigation: {
        nextEl: '[next-item]',
        prevEl: '[prev-item]',
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      on: {
        init: function(slide) {
          $(slide.slides[slide.snapIndex]).closest('.kits-sliders').find('[next-item]').attr('disabled', 'disabled');
        },
        slideChange: function (slide) {
          let slideTarget = $(slide.slides[slide.snapIndex]);
          let buttonAddCart = slideTarget.closest('.kits-sliders-container').find('[add-all-kit-to-cart]');
          let buttonNextItem = slideTarget.closest('.kits-sliders-container').find('[next-item]');
          let buttonPrevItem = slideTarget.closest('.kits-sliders-container').find('[prev-item]');

          let selectedSize = slideTarget.find('.size-swatch-element.check-swatch').length;
          
          //console.log(slide.slides[slide.snapIndex])
          // console.log($(slide.$wrapperEl).find('.size-swatch-element.check-swatch'))
          // console.log('slide changed', slide.snapIndex, slide);
          
          if(selectedSize){
            slideTarget.closest('.kits-sliders').find('[next-item]').removeAttr('disabled')
          }else{
            slideTarget.closest('.kits-sliders').find('[next-item]').attr('disabled', 'disabled');
          }

          // Habilitar/Desabilitar compra
          let index = slide.snapIndex + 1;
          if( index === $(slide.slides).length){
             buttonAddCart.show();
             buttonNextItem.hide();
            console.log(selectedSize)
             if(selectedSize){
               buttonAddCart.removeAttr('disabled');
               return;
             }
               
             buttonAddCart.attr('disabled', 'disabled');
          }else{
             buttonAddCart.hide().attr('disabled', 'disabled');
             buttonNextItem.show();
          }
          
        }
      }
    });

    $(document).on('click', '.size-swatch-element:not([disabled])', function(){
      let sizeName = $(this).attr('data-size-name');
      let containerKit = $(this).closest('.kits-sliders-container');
      let currentPagination = parseInt(containerKit.find('.swiper-pagination-current').text());
      let totalPagination = parseInt(containerKit.find('.swiper-pagination-total').text())
      let allProductKitItems = containerKit.find('.product-kit-item');
      let containerElement = $(this).closest('.product-kit-item');
      let containerSizeOptions = containerElement.find('.selector-size-kit');
     
      $('[change-size-kit]').html('Tamanho: <b>'+sizeName+'</b>');
      
      $(this).closest('.selector-size-kit').find('.size-swatch-element').removeClass('check-swatch');
      containerKit.find('[next-item]').removeAttr('disabled');
      $(this).addClass('check-swatch');

      if(currentPagination===totalPagination){
        allProductKitItems.each(function( index, element ) {
          let hasElement = $(this).find('.size-swatch-element.check-swatch').length > 0;
          
          if(!hasElement) {
            console.log("Selecione o tamanho do item "+index)
            containerKit.find('[add-all-kit-to-cart]').attr('disabled', 'disabled');
            return;
          }
        });

        containerKit.find('[add-all-kit-to-cart]').removeAttr('disabled');

      }
      
    })

    window.updateSliderKit = function(){
      let element = $('.color-swatch-element.check-swatch');
      let containerImages = $('.product-full-width').find('[data-moreview-product-fullWdith]');
      let url = element.attr('data-handle')+"?view=swatch-tamanho-kit";      
        $.get(url, function(data) {
          var html = $('<div></div>').html(data);

          /*Imagens controller*/
          var images = html.find('[data-moreview-product-fullWdith]').html();
          containerImages.html(images);

          // window.checkViewport($(window));
          initProductFullWidthMoreview();
          
          /*Tamanhos controller*/
          var sizes = html.find('.selector-size-kit').html();
          console.log("sizes", sizes)
          containerSizeOptions.html(sizes);
          $('[change-size-kit]').html('Tamanho: ');
        }).fail(function() {
            console.error("Erro ao buscar os dados do JSON.");
        });
      
    }
    
    $(document).on('click', '.color-swatch-element:not(.last-click)', function(){
       // window.destroySlider();
       let swatch = $(this);
       let colorName = $(this).attr('data-color-name');
       let newImage = $(this).attr('data-image-image');
       $('.color-swatch-element').removeClass('last-click');
       swatch.addClass('last-click');
       let containerSlider = $(this).closest('.kits-sliders');
       let containerElement = $(this).closest('.product-kit-item');
       let containerSizeOptions = containerElement.find('.selector-size-kit');
       let containerImages = $('.product-full-width').find('[data-moreview-product-fullWdith]');

      $('[change-image-kit]').attr('src', newImage);

      $('[change-color-kit]').html('Cor: <b>'+colorName+'</b>');
      
       let url = $(this).attr('data-handle')+"?view=swatch-tamanho-kit";
        swatch.closest('.selector-color-kit').find('.color-swatch-element').removeClass('check-swatch');
        swatch.addClass('check-swatch');

        containerSlider.find('[next-item]').attr('disabled', 'disabled');
      
        $.get(url, function(data) {
          var html = $('<div></div>').html(data);

          /*Imagens controller*/
          var images = html.find('[data-moreview-product-fullWdith]').html();
          containerImages.html(images);
          
          initProductFullWidthMoreview();
          
          /*Tamanhos controller*/
          var sizes = html.find('.selector-size-kit').html();
          
          containerSizeOptions.html(sizes);
          $('[change-size-kit]').html('Tamanho: ');
          // window.checkViewport($(window));
        }).fail(function() {
            console.error("Erro ao buscar os dados do JSON.");
        });
      
    })


    function checkQueue(){
      if (window.queue.length) {
        var request = window.queue.shift();
        
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: 'quantity='+request.qtd+'&id='+request.id,
            dataType: 'json',
            success: function(line_item) { 
              checkQueue();
            },
            error: function() {
              checkQueue();
            }
          });
      }
      else {
        window.updateCart();
      }
    }

    $(document).on('click', '[add-all-kit-to-cart]', function() {
        let kitContainer = $(this).closest('.kits-sliders-container');
        let variants = kitContainer.find('.size-swatch-element.check-swatch');
        window.queue = [];
    
        variants.each(function(index, element) {
            let variant = {};
            variant.id = parseInt($(element).attr('variant-id'));
            variant.qtd = 1;
            window.queue.push(variant);
            if(index === (variants.length - 1)){
              checkQueue();
            }
        });

    });
  })